







import { Component, Watch, Vue, Prop } from 'vue-property-decorator'
import * as Types from '../../mini'

@Component({})
export default class Blank extends Vue {
  @Prop() data: Types.Backtop
  @Prop({ default: 'preview-box' }) container: string

  get src() {
    return this.data.cover.url
  }

  mounted() {
    this.data.compMargin = '18'
    try {
      this.$el.parentElement.style.zIndex = '993'
    } catch {}
  }

  goToTop() {
    const container = document.getElementsByClassName(this.container)[0]
    if (container) {
      container.scrollTop = 0
    }
    // if (container.scrollTo) {
    //   container.scrollTo({ top: 0, behavior: 'smooth' })
    // } else {
    //   container.scrollTop = 0
    // }
  }
}
